export default __webpack_public_path__ + "static/media/ToEveryoneFromTLViaJR.c8d70752.pdf";